import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode } from "vue"
import _imports_0 from '@/assets/tooltip.svg'
import _imports_1 from '@/assets/history.svg'
import _imports_2 from '@/assets/deleteIcon.svg'


const _hoisted_1 = { class: "tableCornerRadius bg-white" }
const _hoisted_2 = { class: "table-container" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { key: 0 }
const _hoisted_5 = ["onUpdate:modelValue"]
const _hoisted_6 = ["value"]
const _hoisted_7 = ["value"]
const _hoisted_8 = ["onUpdate:modelValue"]
const _hoisted_9 = ["value"]
const _hoisted_10 = ["value"]
const _hoisted_11 = ["onUpdate:modelValue"]
const _hoisted_12 = ["value"]
const _hoisted_13 = ["value"]
const _hoisted_14 = ["onUpdate:modelValue"]
const _hoisted_15 = ["value"]
const _hoisted_16 = ["value"]
const _hoisted_17 = ["onUpdate:modelValue"]
const _hoisted_18 = ["value"]
const _hoisted_19 = ["value"]
const _hoisted_20 = ["onUpdate:modelValue"]
const _hoisted_21 = ["value"]
const _hoisted_22 = ["value"]
const _hoisted_23 = ["onUpdate:modelValue"]
const _hoisted_24 = ["value"]
const _hoisted_25 = ["value"]
const _hoisted_26 = { key: 7 }
const _hoisted_27 = ["onUpdate:modelValue"]
const _hoisted_28 = { key: 0 }
const _hoisted_29 = { class: "cursor-pointer rowHeight" }
const _hoisted_30 = ["colspan"]
const _hoisted_31 = { class: "flex items-center justify-center w-full h-16 skeleton" }
const _hoisted_32 = { key: 1 }
const _hoisted_33 = { class: "cursor-pointer rowHeight" }
const _hoisted_34 = ["colspan"]
const _hoisted_35 = {
  key: 2,
  class: "nonEmptyTable"
}
const _hoisted_36 = ["onClick"]
const _hoisted_37 = { key: 1 }
const _hoisted_38 = { class: "cursor-pointer text-xs w-26" }
const _hoisted_39 = { key: 2 }
const _hoisted_40 = { class: "cursor-pointer text-xs" }
const _hoisted_41 = { key: 3 }
const _hoisted_42 = ["onMousemove"]
const _hoisted_43 = { key: 4 }
const _hoisted_44 = { class: "flex justify-center" }
const _hoisted_45 = { key: 5 }
const _hoisted_46 = ["onMousemove"]
const _hoisted_47 = ["onMousemove"]
const _hoisted_48 = {
  key: 2,
  class: "flex justify-center items-center bg-white opacity-0 lasttooltip absolute z-50 group-hover:opacity-100 border pointer-events-none"
}
const _hoisted_49 = {
  key: 3,
  class: "flex justify-center items-center bg-white opacity-0 lasttooltip absolute z-50 group-hover:opacity-100 border pointer-events-none cursor-pointer"
}
const _hoisted_50 = { key: 6 }
const _hoisted_51 = ["onMousemove"]
const _hoisted_52 = { key: 7 }
const _hoisted_53 = { key: 0 }
const _hoisted_54 = { class: "text-xs" }
const _hoisted_55 = { key: 1 }
const _hoisted_56 = {
  key: 2,
  class: "flex"
}
const _hoisted_57 = {
  key: 1,
  class: "pl-7"
}
const _hoisted_58 = {
  key: 3,
  class: "flex justify-center"
}
const _hoisted_59 = { key: 0 }
const _hoisted_60 = { class: "relative flex items-center justify-center regular" }
const _hoisted_61 = ["onMousemove"]
const _hoisted_62 = ["onMousemove"]
const _hoisted_63 = { key: 4 }
const _hoisted_64 = { class: "relative flex items-center regular justify-center" }
const _hoisted_65 = ["onMousemove"]
const _hoisted_66 = { key: 5 }
const _hoisted_67 = { class: "text-xs" }
const _hoisted_68 = { key: 6 }
const _hoisted_69 = { class: "text-xs" }
const _hoisted_70 = {
  key: 7,
  class: "flex"
}
const _hoisted_71 = { class: "flex rounded w-32 items-center justify-center py-1 regular text-xs" }
const _hoisted_72 = { class: "text-xs" }
const _hoisted_73 = {
  key: 8,
  class: "flex items-center justify-center"
}
const _hoisted_74 = ["onMousemove"]
const _hoisted_75 = {
  key: 9,
  class: "flex justify-center"
}
const _hoisted_76 = ["onMousemove"]
const _hoisted_77 = {
  key: 10,
  class: "flex justify-center items-center"
}
const _hoisted_78 = { key: 11 }
const _hoisted_79 = { key: 12 }
const _hoisted_80 = {
  key: 0,
  style: {"display":"flex","align-items":"center","justify-content":"center"}
}
const _hoisted_81 = { key: 1 }
const _hoisted_82 = { key: 13 }
const _hoisted_83 = { class: "table-ellipsis" }
const _hoisted_84 = ["onMousemove"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_dots_loader = _resolveComponent("dots-loader")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Menu = _resolveComponent("Menu")!
  const _component_pagination = _resolveComponent("pagination")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("table", null, [
        _createElementVNode("thead", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.columnNames, (presentColumn) => {
            return (_openBlock(), _createElementBlock("th", {
              scope: "col",
              key: presentColumn,
              class: _normalizeClass([_ctx.getColumnHeadWidth(presentColumn), "bg-white capitalize"]),
              onClick: ($event: any) => (_ctx.sort(presentColumn))
            }, [
              (presentColumn=='systemStatus'||presentColumn=='vendorStatus'||presentColumn=='risks'||presentColumn=='criticality'||presentColumn=='severity'||presentColumn=='securityCategory'||presentColumn=='likelihood'||_ctx.column=='Facing')
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: _normalizeClass(["flex justify-center", _ctx.getHeaderAlignment(presentColumn)])
                  }, [
                    _createElementVNode("div", null, _toDisplayString(_ctx.getColumnLabel(presentColumn)), 1),
                    (_ctx.getColumnLabel(presentColumn) != '')
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 0,
                          class: _normalizeClass(["sort cursor-pointer", _ctx.className == presentColumn ? _ctx.classSort : 'opacity-50'])
                        }, null, 2))
                      : _createCommentVNode("", true)
                  ], 2))
                : (_openBlock(), _createElementBlock("div", {
                    key: 1,
                    class: _normalizeClass(["flex", _ctx.getHeaderAlignment(presentColumn)])
                  }, [
                    _createElementVNode("div", null, _toDisplayString(_ctx.getColumnLabel(presentColumn)), 1),
                    (_ctx.getColumnLabel(presentColumn) != '')
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 0,
                          class: _normalizeClass(["sort cursor-pointer", _ctx.className == presentColumn ? _ctx.classSort : 'opacity-50'])
                        }, null, 2))
                      : _createCommentVNode("", true)
                  ], 2))
            ], 10, _hoisted_3))
          }), 128)),
          (_ctx.visibility)
            ? (_openBlock(), _createElementBlock("tr", _hoisted_4, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.columnNames, (presentColumn, index) => {
                  return (_openBlock(), _createElementBlock("td", {
                    class: _normalizeClass([[presentColumn === 'status' ? 'flex items-center justify-center' : ''], "bg-white"]),
                    key: index
                  }, [
                    _createElementVNode("div", {
                      class: _normalizeClass(_ctx.getFilterAlignment(presentColumn))
                    }, [
                      (_ctx.isColumnArrayPresent(presentColumn) && presentColumn != 'priority')
                        ? _withDirectives((_openBlock(), _createElementBlock("select", {
                            key: 0,
                            class: _normalizeClass(["filter-font-size", _ctx.filters[presentColumn] == null ? 'inputboxstylingForSelect' : 'stylingForInputboxstylingForSelect']),
                            "onUpdate:modelValue": ($event: any) => ((_ctx.filters[presentColumn]) = $event)
                          }, [
                            _createElementVNode("option", {
                              value: _ctx.filters.presentColumn,
                              selected: "",
                              hidden: "",
                              disabled: ""
                            }, "Select", 8, _hoisted_6),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getDropdownOptionsForFilter(presentColumn), (option) => {
                              return (_openBlock(), _createElementBlock("option", {
                                class: "optionColors",
                                key: option.id,
                                value: option.id
                              }, _toDisplayString(option.value), 9, _hoisted_7))
                            }), 128))
                          ], 10, _hoisted_5)), [
                            [_vModelSelect, _ctx.filters[presentColumn]]
                          ])
                        : (presentColumn == 'priority')
                          ? _withDirectives((_openBlock(), _createElementBlock("select", {
                              key: 1,
                              class: _normalizeClass(["filter-font-size", _ctx.filters[presentColumn] == null ? 'inputboxstylingForSelect' : 'stylingForInputboxstylingForSelect']),
                              "onUpdate:modelValue": ($event: any) => ((_ctx.filters[presentColumn]) = $event)
                            }, [
                              _createElementVNode("option", {
                                value: _ctx.filters.presentColumn,
                                selected: "",
                                hidden: "",
                                disabled: ""
                              }, "Select", 8, _hoisted_9),
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getDbDropdownOptionsForFilter(presentColumn), (option) => {
                                return (_openBlock(), _createElementBlock("option", {
                                  class: "optionColors",
                                  key: option,
                                  value: option.value
                                }, _toDisplayString(option.key), 9, _hoisted_10))
                              }), 128))
                            ], 10, _hoisted_8)), [
                              [_vModelSelect, _ctx.filters[presentColumn]]
                            ])
                          : (_ctx.isColumnArrayPresentibDB(presentColumn))
                            ? _withDirectives((_openBlock(), _createElementBlock("select", {
                                key: 2,
                                class: _normalizeClass(["filter-font-size", _ctx.filters[presentColumn] == null ? 'inputboxstylingForSelect' : 'stylingForInputboxstylingForSelect']),
                                "onUpdate:modelValue": ($event: any) => ((_ctx.filters[presentColumn]) = $event)
                              }, [
                                _createElementVNode("option", {
                                  value: _ctx.filters.presentColumn,
                                  selected: "",
                                  hidden: "",
                                  disabled: ""
                                }, "Select", 8, _hoisted_12),
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getDbDropdownOptionsForFilter(presentColumn), (option) => {
                                  return (_openBlock(), _createElementBlock("option", {
                                    class: "optionColors",
                                    key: option,
                                    value: option.value
                                  }, _toDisplayString(option.key), 9, _hoisted_13))
                                }), 128))
                              ], 10, _hoisted_11)), [
                                [_vModelSelect, _ctx.filters[presentColumn]]
                              ])
                            : (presentColumn == 'vendorStatus'||presentColumn == 'systemStatus')
                              ? _withDirectives((_openBlock(), _createElementBlock("select", {
                                  key: 3,
                                  "onUpdate:modelValue": ($event: any) => ((_ctx.filters[presentColumn]) = $event),
                                  class: _normalizeClass(_ctx.filters[presentColumn] == null ? 'inputboxstylingForSelect' : 'stylingForInputboxstylingForSelect')
                                }, [
                                  _createElementVNode("option", {
                                    value: _ctx.select,
                                    selected: "",
                                    hidden: "",
                                    disabled: ""
                                  }, "Select", 8, _hoisted_15),
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.activeValues, (pair) => {
                                    return (_openBlock(), _createElementBlock("option", {
                                      class: "optionColors",
                                      key: pair,
                                      value: pair.id
                                    }, _toDisplayString(pair.value), 9, _hoisted_16))
                                  }), 128))
                                ], 10, _hoisted_14)), [
                                  [_vModelSelect, _ctx.filters[presentColumn]]
                                ])
                              : (presentColumn == 'Facing')
                                ? _withDirectives((_openBlock(), _createElementBlock("select", {
                                    key: 4,
                                    "onUpdate:modelValue": ($event: any) => ((_ctx.filters[presentColumn]) = $event),
                                    class: _normalizeClass(_ctx.filters[presentColumn] == null ? 'inputboxstylingForSelect' : 'stylingForInputboxstylingForSelect')
                                  }, [
                                    _createElementVNode("option", {
                                      value: _ctx.select,
                                      selected: "",
                                      hidden: "",
                                      disabled: ""
                                    }, "Select", 8, _hoisted_18),
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.yesNo, (pair) => {
                                      return (_openBlock(), _createElementBlock("option", {
                                        class: "optionColors",
                                        key: pair,
                                        value: pair.id
                                      }, _toDisplayString(pair.value), 9, _hoisted_19))
                                    }), 128))
                                  ], 10, _hoisted_17)), [
                                    [_vModelSelect, _ctx.filters[presentColumn]]
                                  ])
                                : (presentColumn == 'criticality')
                                  ? _withDirectives((_openBlock(), _createElementBlock("select", {
                                      key: 5,
                                      class: _normalizeClass(_ctx.filters[presentColumn] == null ? 'inputboxstylingForSelect' : 'stylingForInputboxstylingForSelect'),
                                      "onUpdate:modelValue": ($event: any) => ((_ctx.filters[presentColumn]) = $event)
                                    }, [
                                      _createElementVNode("option", {
                                        value: _ctx.select,
                                        selected: "",
                                        disabled: "",
                                        hidden: ""
                                      }, "Select", 8, _hoisted_21),
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dbProcessCriticality, (value) => {
                                        return (_openBlock(), _createElementBlock("option", {
                                          class: "optionColors",
                                          key: value.value,
                                          value: value.value
                                        }, _toDisplayString(value.key), 9, _hoisted_22))
                                      }), 128))
                                    ], 10, _hoisted_20)), [
                                      [_vModelSelect, _ctx.filters[presentColumn]]
                                    ])
                                  : _createCommentVNode("", true),
                      (presentColumn=='relationshipType')
                        ? _withDirectives((_openBlock(), _createElementBlock("select", {
                            key: 6,
                            class: _normalizeClass([_ctx.filters[presentColumn] == null ? 'inputboxstylingForSelect criticalitystyling' : 'stylingForInputboxstylingForSelect criticalitystyling', "widthForRelationTypeSelect"]),
                            "onUpdate:modelValue": ($event: any) => ((_ctx.filters[presentColumn]) = $event)
                          }, [
                            _createElementVNode("option", {
                              value: _ctx.filters.presentColumn,
                              selected: "",
                              hidden: "",
                              disabled: ""
                            }, "Select", 8, _hoisted_24),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.relationShipType, (pair) => {
                              return (_openBlock(), _createElementBlock("option", {
                                class: "optionColors",
                                key: pair,
                                value: pair.id
                              }, _toDisplayString(pair.value), 9, _hoisted_25))
                            }), 128))
                          ], 10, _hoisted_23)), [
                            [_vModelSelect, _ctx.filters[presentColumn]]
                          ])
                        : (_ctx.isFilterNotNecessary(presentColumn))
                          ? (_openBlock(), _createElementBlock("div", _hoisted_26))
                          : (_ctx.shouldShowDisabled(presentColumn))
                            ? _withDirectives((_openBlock(), _createElementBlock("input", {
                                key: 8,
                                type: "text",
                                class: "disabledinputboxstyling",
                                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.filters[_ctx.columnName]) = $event)),
                                disabled: "",
                                placeholder: ""
                              }, null, 512)), [
                                [_vModelText, _ctx.filters[_ctx.columnName]]
                              ])
                            : (!_ctx.dropdownColumns.includes(presentColumn))
                              ? _withDirectives((_openBlock(), _createElementBlock("input", {
                                  key: 9,
                                  type: "text",
                                  class: "searchForInputBoxStyling filter-font-size",
                                  "onUpdate:modelValue": ($event: any) => ((_ctx.filters[presentColumn]) = $event),
                                  placeholder: "Search"
                                }, null, 8, _hoisted_27)), [
                                  [_vModelText, _ctx.filters[presentColumn]]
                                ])
                              : _createCommentVNode("", true)
                    ], 2)
                  ], 2))
                }), 128))
              ]))
            : _createCommentVNode("", true)
        ]),
        (_ctx.loadData == true)
          ? (_openBlock(), _createElementBlock("tbody", _hoisted_28, [
              _createElementVNode("tr", _hoisted_29, [
                _createElementVNode("td", {
                  class: "relative h-5",
                  colspan: _ctx.columnNames.size
                }, [
                  _createElementVNode("div", _hoisted_31, [
                    _createVNode(_component_dots_loader)
                  ])
                ], 8, _hoisted_30)
              ])
            ]))
          : (_ctx.sortedData.length == 0)
            ? (_openBlock(), _createElementBlock("tbody", _hoisted_32, [
                _createElementVNode("tr", _hoisted_33, [
                  _createElementVNode("td", {
                    class: "relative h-10",
                    colspan: _ctx.columnNames.size
                  }, _cache[2] || (_cache[2] = [
                    _createElementVNode("div", { class: "flex justify-center" }, [
                      _createElementVNode("p", { class: "text-xs font-normal" }, "No Records Found")
                    ], -1)
                  ]), 8, _hoisted_34)
                ])
              ]))
            : (_openBlock(), _createElementBlock("tbody", _hoisted_35, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sortedData, (row, index) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    key: row,
                    class: "cursor-pointer rowHeight"
                  }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.columnNames, (presentColumn) => {
                      return (_openBlock(), _createElementBlock("td", {
                        key: presentColumn,
                        onMouseout: _cache[1] || (_cache[1] = ($event: any) => (_ctx.doFalse())),
                        onClick: ($event: any) => (_ctx.actionOnClickingTableRow(row, index, presentColumn)),
                        class: "cursor-pointer relative"
                      }, [
                        (row[presentColumn] == '')
                          ? (_openBlock(), _createElementBlock("div", {
                              key: 0,
                              class: _normalizeClass({'w-24 text-center':presentColumn == 'securityCategory'})
                            }, _toDisplayString('N/A'), 2))
                          : (_ctx.checkDateFormat(presentColumn))
                            ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                                _createElementVNode("p", _hoisted_38, _toDisplayString(_ctx.getDateFormat(row[presentColumn])), 1)
                              ]))
                            : (_ctx.checkuserData(presentColumn))
                              ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                                  _createElementVNode("div", _hoisted_40, _toDisplayString(Object.keys(row[presentColumn]).includes('label') ? `${row[presentColumn].label}`:`${_ctx.getOwnerName(row[presentColumn])}`), 1)
                                ]))
                              : (presentColumn == 'systemCount' ||presentColumn == 'risks')
                                ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
                                    _createElementVNode("div", {
                                      class: "flex items-center justify-center",
                                      onMousemove: ($event: any) => (_ctx.toolTip(presentColumn, $event, index, row, 'text'))
                                    }, _toDisplayString(row[presentColumn]), 41, _hoisted_42)
                                  ]))
                                : (presentColumn == 'Facing')
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_43, [
                                      _createElementVNode("div", _hoisted_44, _toDisplayString(_ctx.isPublicFacing(row[presentColumn])), 1)
                                    ]))
                                  : (presentColumn == 'vendorStatus' ||presentColumn == 'systemStatus')
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_45, [
                                        (row[presentColumn] == true)
                                          ? (_openBlock(), _createElementBlock("div", {
                                              key: 0,
                                              class: "rounded-full w-5 h-5 bg-active mx-auto",
                                              onMousemove: ($event: any) => (_ctx.toolTip(presentColumn, $event, index, row, 'circleButton'))
                                            }, null, 40, _hoisted_46))
                                          : (_openBlock(), _createElementBlock("div", {
                                              key: 1,
                                              class: "rounded-full w-5 h-5 bg-error mx-auto",
                                              onMousemove: ($event: any) => (_ctx.toolTip(presentColumn, $event, index, row, 'circleButton'))
                                            }, null, 40, _hoisted_47)),
                                        (row[presentColumn] == true && _ctx.pop == true)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_48, _cache[3] || (_cache[3] = [
                                              _createElementVNode("img", {
                                                src: _imports_0,
                                                alt: "",
                                                class: "absolute text-black bottom-full left-0 -mb-1 h-3.5 w-3"
                                              }, null, -1),
                                              _createElementVNode("span", { class: "text-black text-center text-xs" }, null, -1),
                                              _createTextVNode(" Active ")
                                            ])))
                                          : _createCommentVNode("", true),
                                        (row[presentColumn] == false && _ctx.pop == true)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_49, _cache[4] || (_cache[4] = [
                                              _createElementVNode("img", {
                                                src: _imports_0,
                                                alt: "",
                                                class: "absolute text-black bottom-full left-0 -mb-1 h-3.5 w-3"
                                              }, null, -1),
                                              _createElementVNode("span", { class: "text-black text-center text-xs" }, null, -1),
                                              _createTextVNode(" Inactive ")
                                            ])))
                                          : _createCommentVNode("", true)
                                      ]))
                                    : (presentColumn=='relationshipType')
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_50, [
                                          _createElementVNode("div", {
                                            class: "table-ellipsis",
                                            onMousemove: ($event: any) => (_ctx.toolTip(presentColumn, $event, index, row, 'text'))
                                          }, _toDisplayString(_ctx.getRelationshipType(row[presentColumn])), 41, _hoisted_51)
                                        ]))
                                      : (_ctx.isColumnArrayPresent(presentColumn))
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_52, [
                                            (presentColumn == 'tier' || presentColumn == 'mitigationTier')
                                              ? (_openBlock(), _createElementBlock("div", _hoisted_53, [
                                                  _createElementVNode("div", _hoisted_54, _toDisplayString(_ctx.getColumnRealtedValueFromArray(row[presentColumn], presentColumn)), 1)
                                                ]))
                                              : (presentColumn == 'subCategory')
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_55, _toDisplayString(_ctx.getColumnRealtedValueFromArray(row[presentColumn], presentColumn)), 1))
                                                : (presentColumn == 'prioritypreview')
                                                  ? (_openBlock(), _createElementBlock("div", _hoisted_56, [
                                                      (row[presentColumn])
                                                        ? (_openBlock(), _createElementBlock("div", {
                                                            key: 0,
                                                            class: _normalizeClass(["flex items-center justify-center rounded h-5 w-24 px-2.5 regular", _ctx.bgColorForPriority(row[presentColumn])])
                                                          }, [
                                                            _createElementVNode("div", {
                                                              class: _normalizeClass(_ctx.textColorForPriority(row[presentColumn]))
                                                            }, _toDisplayString(_ctx.dbPriority.find((l) => {
                                                    return l?.value == row[presentColumn];
                                                })?.key|| 'N/A'), 3)
                                                          ], 2))
                                                        : (_openBlock(), _createElementBlock("div", _hoisted_57, " - "))
                                                    ]))
                                                  : (_ctx.getLabelsArrayForColumnInStore(presentColumn))
                                                    ? (_openBlock(), _createElementBlock("div", _hoisted_58, [
                                                        (presentColumn == 'severitypreview')
                                                          ? (_openBlock(), _createElementBlock("div", _hoisted_59, [
                                                              _createElementVNode("div", _hoisted_60, [
                                                                _createElementVNode("div", {
                                                                  class: _normalizeClass(["flex items-center justify-center rounded-full w-5 h-5", _ctx.colorPropBg('border', row.severitypreview)]),
                                                                  onMousemove: ($event: any) => (_ctx.toolTip(presentColumn, $event, index, row, 'circle'))
                                                                }, [
                                                                  _createElementVNode("div", {
                                                                    class: _normalizeClass(["severityCircle rounded-full", _ctx.colorPropBg('circle', row.severitypreview)])
                                                                  }, null, 2)
                                                                ], 42, _hoisted_61)
                                                              ])
                                                            ]))
                                                          : (_openBlock(), _createElementBlock("div", {
                                                              key: 1,
                                                              class: _normalizeClass(["rounded h-5 w-28 mt-2 mb-3 flex items-center justify-center", _ctx.colorRiskBg(row[presentColumn])]),
                                                              onMousemove: ($event: any) => (_ctx.toolTip(presentColumn, $event, index, row, 'text'))
                                                            }, [
                                                              _createElementVNode("div", {
                                                                class: _normalizeClass(_ctx.colorRiskText(row[presentColumn]))
                                                              }, _toDisplayString(_ctx.getLabelDefinationName( row[presentColumn] )), 3)
                                                            ], 42, _hoisted_62))
                                                      ]))
                                                    : (presentColumn == 'severity')
                                                      ? (_openBlock(), _createElementBlock("div", _hoisted_63, [
                                                          _createElementVNode("div", _hoisted_64, [
                                                            _createElementVNode("div", {
                                                              class: _normalizeClass(["flex items-center justify-center rounded-full w-5 h-5", _ctx.colorPropBg('border', row.severity)]),
                                                              onMousemove: ($event: any) => (_ctx.toolTip(presentColumn, $event, index, row, 'circle'))
                                                            }, [
                                                              _createElementVNode("div", {
                                                                class: _normalizeClass(["severityCircle rounded-full", _ctx.colorPropBg('circle', row.severity)])
                                                              }, null, 2)
                                                            ], 42, _hoisted_65)
                                                          ])
                                                        ]))
                                                      : (presentColumn == 'publicFacing')
                                                        ? (_openBlock(), _createElementBlock("div", _hoisted_66, [
                                                            _createElementVNode("div", _hoisted_67, _toDisplayString(_ctx.getColumnRealtedValueFromArray(row[presentColumn], presentColumn)), 1)
                                                          ]))
                                                        : (presentColumn == 'type')
                                                          ? (_openBlock(), _createElementBlock("div", _hoisted_68, [
                                                              _createElementVNode("div", _hoisted_69, _toDisplayString(_ctx.getColumnRealtedValueFromArray(row[presentColumn], presentColumn)), 1)
                                                            ]))
                                                          : (presentColumn == 'treatmentType')
                                                            ? (_openBlock(), _createElementBlock("div", _hoisted_70, [
                                                                _createElementVNode("div", {
                                                                  class: _normalizeClass(["flex items-center justify-center rounded h-5 w-24 px-2.5 regular", _ctx.bgColorForTreatmentType(row[presentColumn])])
                                                                }, [
                                                                  _createElementVNode("div", {
                                                                    class: _normalizeClass(_ctx.textColorForTreatmentType(row[presentColumn]))
                                                                  }, _toDisplayString(_ctx.getColumnRealtedValueFromArray(row[presentColumn], presentColumn)), 3)
                                                                ], 2)
                                                              ]))
                                                            : (_openBlock(), _createElementBlock("div", {
                                                                key: 8,
                                                                class: _normalizeClass(["flex items-center justify-center relative rounded w-24 px-2.5 h-5 regular", _ctx.colorsForStatusesText(row[presentColumn])])
                                                              }, [
                                                                _createElementVNode("div", {
                                                                  class: _normalizeClass(["w-full h-full absolute opacity-20 rounded", _ctx.bgColorsForStatuses(row[presentColumn])])
                                                                }, null, 2),
                                                                _createElementVNode("div", _hoisted_71, [
                                                                  _createElementVNode("div", _hoisted_72, _toDisplayString(_ctx.getColumnRealtedValueFromArray(row[presentColumn], presentColumn)), 1)
                                                                ])
                                                              ], 2))
                                          ]))
                                        : (presentColumn == 'impact'||presentColumn=='overallImpact')
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_73, [
                                              _createElementVNode("div", {
                                                class: _normalizeClass(["flex items-center justify-center rounded h-5 w-28 px-2.5", _ctx.colorRiskBg(row[presentColumn])]),
                                                onMousemove: ($event: any) => (_ctx.toolTip(presentColumn, $event, index, row,'label'))
                                              }, [
                                                _createElementVNode("div", {
                                                  class: _normalizeClass(["table-ellipsisForValue", _ctx.colorRiskText(row[presentColumn])]),
                                                  style: {"white-space":"break-spaces"}
                                                }, _toDisplayString(_ctx.getLabelFromColumnArrayStoreImpact(row[presentColumn])), 3)
                                              ], 42, _hoisted_74)
                                            ]))
                                          : (_ctx.getLabelsArrayForColumnInStore(presentColumn))
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_75, [
                                                _createElementVNode("div", {
                                                  class: _normalizeClass(["flex items-center justify-center rounded h-5 w-28 px-2.5 regular", _ctx.colorRiskBg(row[presentColumn])]),
                                                  onMousemove: ($event: any) => (_ctx.toolTip(presentColumn, $event, index, row, 'label'))
                                                }, [
                                                  _createElementVNode("div", {
                                                    class: _normalizeClass(["table-ellipsisForValue", _ctx.colorRiskText(row[presentColumn])]),
                                                    style: {"white-space":"break-spaces"}
                                                  }, _toDisplayString(_ctx.getLabelDefinationName(row[presentColumn])), 3)
                                                ], 42, _hoisted_76)
                                              ]))
                                            : (presentColumn == 'History' ||presentColumn=='inActiveHistory')
                                              ? (_openBlock(), _createElementBlock("div", _hoisted_77, _cache[5] || (_cache[5] = [
                                                  _createElementVNode("div", { class: "h-5 w-5" }, [
                                                    _createElementVNode("img", {
                                                      src: _imports_1,
                                                      class: "cursor-pointer h-5 w-5"
                                                    })
                                                  ], -1)
                                                ])))
                                              : (presentColumn == 'deleteIcon' || presentColumn == 'deleteinfo')
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_78, _cache[6] || (_cache[6] = [
                                                    _createElementVNode("div", { class: "flex justify-center h-5 w-5" }, [
                                                      _createElementVNode("img", {
                                                        src: _imports_2,
                                                        class: "h-5 cursor-pointer w-5 mx-2.5"
                                                      })
                                                    ], -1)
                                                  ])))
                                                : (presentColumn == 'actionButton' || presentColumn == 'tableDataActions')
                                                  ? (_openBlock(), _createElementBlock("div", _hoisted_79, [
                                                      (presentColumn == 'actionButton')
                                                        ? (_openBlock(), _createElementBlock("div", _hoisted_80, [
                                                            _createElementVNode("fieldset", null, [
                                                              _createVNode(_component_Button, {
                                                                type: "button",
                                                                icon: "pi pi-ellipsis-v",
                                                                onClick: ($event: any) => (_ctx.actionToggleMenu($event, index)),
                                                                style: {"background-color":"white","color":"black","border":"white"}
                                                              }, null, 8, ["onClick"]),
                                                              _createVNode(_component_Menu, {
                                                                ref_for: true,
                                                                ref: 'menu' + index,
                                                                model: _ctx.actionItems(row),
                                                                popup: true,
                                                                class: "menuWidth"
                                                              }, null, 8, ["model"])
                                                            ])
                                                          ]))
                                                        : (presentColumn == 'tableDataActions')
                                                          ? (_openBlock(), _createElementBlock("div", _hoisted_81, [
                                                              _createElementVNode("fieldset", null, [
                                                                _createVNode(_component_Button, {
                                                                  type: "button",
                                                                  icon: "pi pi-ellipsis-v",
                                                                  onClick: ($event: any) => (_ctx.actionToggleMenu($event, index)),
                                                                  style: {"background-color":"white","color":"black","border":"white"}
                                                                }, null, 8, ["onClick"]),
                                                                _createVNode(_component_Menu, {
                                                                  ref_for: true,
                                                                  ref: 'menu' + index,
                                                                  model: _ctx.tableActionsItems(row,index),
                                                                  popup: true,
                                                                  class: "menuWidth"
                                                                }, null, 8, ["model"])
                                                              ])
                                                            ]))
                                                          : _createCommentVNode("", true)
                                                    ]))
                                                  : (_openBlock(), _createElementBlock("div", _hoisted_82, [
                                                      _createElementVNode("div", _hoisted_83, [
                                                        _createElementVNode("div", {
                                                          onMousemove: ($event: any) => (_ctx.toolTip(presentColumn, $event, index, row, 'text'))
                                                        }, _toDisplayString(row[presentColumn]), 41, _hoisted_84)
                                                      ])
                                                    ]))
                      ], 40, _hoisted_36))
                    }), 128))
                  ]))
                }), 128))
              ]))
      ])
    ]),
    _createVNode(_component_pagination, {
      dynamicPagination: _ctx.dynamicPagination,
      onCurrentPageUpdate: _ctx.paginationUpdations,
      entityId: _ctx.entityId,
      sortedData: _ctx.sortedData
    }, null, 8, ["dynamicPagination", "onCurrentPageUpdate", "entityId", "sortedData"])
  ]))
}